/**
 * Service page copy, adapted from `Bluebird Service.dc.html`.
 * See `shop.ts` for what may and may not change in a copy pass.
 *
 * Ryan confirmed the service process in person on 2026-08-25: call or text
 * first, then bring the bike in. Bench work is first come, first served because
 * parts and the inspection can change the turnaround.
 */
export const service = {
  hero: {
    line1: "Cargo bike service",
    line2: "without the guesswork",
    intro:
      "We service cargo bikes purchased from our shop. Call or text before you bring yours in so we can hear what it is doing and tell you what to expect.",
    cta: "Call or text the shop",
    photoNote: "photo, full-bleed — Zach at the bench, cargo bike in the stand",
  },

  costs: {
    // SOURCE: Ryan email 2026-05-19 (Gmail thread 19bdc36277a09e6f) —
    // "$45 for a safety inspection. Our tunes start at $180 for bikes,
    // and we add on based on what bikes need. Typically we do one of
    // these per year."
    heading: "What it costs",
    cards: [
      {
        figure: "$45",
        title: "Safety inspection",
        body:
          "Choose this when you want the brakes, tires, steering, drivetrain, and key fasteners checked before the next loaded ride.",
      },
      {
        figure: "from $180",
        title: "Tunes",
        body:
          "For regular wear and adjustment. The final price depends on the bike and the work it needs.",
      },
      {
        figure: "Everything else",
        title: null,
        body:
          "Tell us what the bike is doing. We inspect it and explain the recommended work and price before starting.",
      },
    ],
  },

  how: {
    heading: "How it works",
    steps: [
      {
        before: "Call or text before you bring the bike in. Tell us what it is doing and whether it is safe to ride.",
        after: null,
      },
      {
        before: "Bring it to the shop. Service is first come, first served, and timing depends on the work and any parts it needs.",
        after: null,
      },
      {
        before: "We inspect it, explain the work and price, then tell you when it should be ready.",
        after: null,
      },
    ],
    cta: "Call the shop",
    scheduleHeading: "Start with a call or text",
    scheduleBody:
      "A short conversation is the fastest way to tell whether the bike is safe to ride in, what to bring, and what turnaround to expect.",
    callCta: "Call 303-263-6549",
    textCta: "Text the shop",
    photoNote: "photo — the workshop wall, tools and box-bike parts",
  },

  elsewhere: {
    heading: "Was the bike purchased somewhere else?",
    body:
      "We primarily service bikes sold by Front Range. If yours came from another shop, contact us before making the trip and we will tell you whether we can help.",
    cta: "Contact the shop",
  },
} as const;
